import { Type } from 'lucide-react';

interface FontOption {
  value: string;
  label: string;
}

interface FontFamilySelectProps {
  id: string;
  label: string;
  description?: string;
  value: string;
  options: FontOption[];
  onChange: (value: string) => void;
  readOnly?: boolean;
}

export function FontFamilySelect({
  id,
  label,
  description,
  value,
  options,
  onChange,
  readOnly = false,
}: FontFamilySelectProps) {
  return (
    <div className="token-input space-y-2">
      {/* Label */}
      <div>
        <label htmlFor={id} className="block text-sm font-medium text-gray-700">
          {label}
        </label>
        {description && (
          <p className="text-xs text-gray-500 mt-0.5">{description}</p>
        )}
      </div>

      {/* Select Dropdown */}
      <div className="relative">
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          disabled={readOnly}
          className="input w-full pl-9"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <Type className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none" />
      </div>

      {/* Font Preview */}
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
        <p
          className="text-2xl text-gray-900"
          style={{ fontFamily: value }}
        >
          Anteprima Font
        </p>
        <p
          className="text-sm text-gray-600 mt-2"
          style={{ fontFamily: value }}
        >
          The quick brown fox jumps over the lazy dog
        </p>
        <p className="text-xs text-gray-500 mt-2 font-mono">
          Font: {value}
        </p>
      </div>
    </div>
  );
}
